/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/__generated__/WidgetConfigurationNavEntryPointQuery$parameters.ts';
import type { WidgetConfigurationNavEntryPointQuery } from './ui/__generated__/WidgetConfigurationNavEntryPointQuery.graphql.ts';

type HorizontalNavigationCsmWidgetConfigurationEntryPointComponent = EntryPointComponent<
	{
		WidgetConfigurationNavEntryPointQuery: WidgetConfigurationNavEntryPointQuery;
	},
	{},
	{},
	{} | null
>;

export const horizontalNavigationCsmWidgetConfigurationEntryPoint: EntryPoint<
	HorizontalNavigationCsmWidgetConfigurationEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HorizontalNavigationCsmWidgetConfigurationEntryPointComponent>(
		/* webpackChunkName: "async-horizontal-navigation-csm-widget-configuration-entrypoint" */ './ui/WidgetConfigurationNavEntryPoint.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, widgetId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				WidgetConfigurationNavEntryPointQuery: {
					parameters,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
						widgetId: widgetId ?? '',
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
